<!-- Spinner -->
<ng-template #spinner>
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
</ng-template>

<!-- Breadcrumb Separator -->
<ng-template #breadcrumb_separator_template>
  <div class="mdsf-breadcrum d-none d-md-flex">
    <span class="mdsf-breadcrumb-separator">&nbsp;|&nbsp;</span>
  </div>
</ng-template>

<!-- Breadcrumb Entry -->
<ng-template #breadcrumb_entry_template let-page="page" let-routeElement="routeElement" let-routerLink="routerLink" let-themeColor="themeColor">
  <div class="mdsf-breadcrum d-none d-md-flex" [routerLink]="[routerLink ?? '/' + routeElement?.path]">
    <span><a [routerLink]="[routerLink ?? '/' + routeElement?.path]" class="{{ themeColor }}">{{ page.title }}</a></span>
  </div>
</ng-template>

<!-- Breadcrumbs -->

<!-- Dropdown -->
<ng-template #dropdown_template let-user="user" let-settings="settings" let-page="page">
  <div ngbDropdown
    #menu="ngbDropdown"
    class="left d-flex d-md-none"
    container="body">
    <div ngbDropdownToggle
    class="mdsf-btn fa fa-2x fa-bars"></div>
    <div ngbDropdownMenu
      aria-labelledby="home-menu">
      <button ngbDropdownItem
        [routerLink]="'/'"><i class="fa fa-home-alt"></i> Home</button>
        @if (user === null) {
          <a [href]="authControlService.getOidcAuthLoginUrl()" ngbDropdownItem>
            <i class="fa fa-sign-in"></i> {{ 'sign_in' | translate }}
          </a>
        }
        @if (settings && !settings.hideDownloadPdf && page && page.pdfMedia && {pdfMedia: (appSharedFacade.media$(page.pdfMedia) | async), pdfMediaAuthor: (appSharedFacade.media$(page.pdfMediaAuthor) | async)}; as pdfMetaData) {
          <button ngbDropdownItem
            (click)="downloadPDF(pdfMetaData.pdfMedia)">
            <i class="fa fa-download"></i> {{ 'show_pdf' | translate }}
          </button>
        }
        @if ((navigationControlFacade.showSearch$ | async)) {
          <button ngbDropdownItem
            (click)="openModal()"
            >
            <i class="fa fa-search"></i> {{ 'search' | translate }}
          </button>
        }
        @if (user) {
          <button ngbDropdownItem
            (click)="logout()"
            >
            <i class="fa fa-sign-out"></i> {{ 'sign_out' | translate }}
          </button>
        }
        <medsurf-sidebar [showCurrentSubject]="true"
          (blockSelected)="menu.close()"
          (specialPageSelected)="menu.close()">
        </medsurf-sidebar>
        <button ngbDropdownItem
          (click)="navigationControlService.selectLink({path: 'seite', params: {pageSlug: 'privacy'}})">
          DATENSCHUTZERKLÄRUNG
        </button>
        <button ngbDropdownItem
          (click)="navigationControlService.selectLink({path: 'seite', params: {pageSlug: 'impressum'}})">
          IMPRESSUM
        </button>
        <button ngbDropdownItem
          (click)="navigationControlService.selectLink({path: 'seite', params: {pageSlug: 'feedback'}})">
          FEEDBACK
        </button>
      </div>
    </div>
  </ng-template>

  <!-- Right -->
  <ng-template #right_template let-user="user" let-settings="settings" let-page="page" let-currentUrl="currentUrl">
    <div class="right">
      <div class="w-auto" ngbDropdown>
        <div class="mdsf-btn w-100 px-3 d-none d-md-flex mdsf-hitarea" :title="{{ 'user_profile' | translate }}" ngbDropdownToggle>
          @if (user) {
            <i class="fa fa-user-circle"></i> <span class="ml-2 font-semibold text-base">{{ user.email }}</span>
          } @else {
            <i class="fa fa-user-circle"></i>
          }
          <i class="fa fa-caret-down fa-xs ml-2"></i>
        </div>
        <div aria-labelledby="simple-dropdown"
          ngbDropdownMenu>
          @if (user) {
            @if (user?.role === 'admin') {
              <a (click)="editInAuthor(currentUrl)"
                ngbDropdownItem>
                <i class="fa fa-edit"></i> {{ 'edit' | translate }}
              </a>
              <div class="dropdown-divider"></div>
            }
            <a (click)="logout()"
              ngbDropdownItem>
              <i class="fa fa-sign-out"></i> {{ 'sign_out' | translate }}
            </a>
          }
          @if (user === null) {
            <a [href]="authControlService.getOidcAuthLoginUrl()" ngbDropdownItem>
              <i class="fa fa-sign-in"></i> {{ 'sign_in' | translate }}
            </a>
          }
        </div>
      </div>
      @if (settings && !settings.hideDownloadPdf && page && (page.pdfMedia || (page.pdfMediaAuthor && user && user?.role !== 'viewer')) && {pdfMedia: (appSharedFacade.media$(page.pdfMedia) | async), pdfMediaAuthor: (appSharedFacade.media$(page.pdfMediaAuthor) | async)}; as pdfMetaData) {
        <div class="mdsf-btn mdsf-hitarea d-none d-md-flex"
          [routerLink]=""
          (click)="downloadPDF(pdfMetaData.pdfMedia)"
          [class.is-printing]="(navigationControlFacade.isPrinting$ | async)">
          <i class="fa fa-download" title="{{ 'open_print_page' | translate }}"></i>
        </div>
      }
      @if ((navigationControlFacade.showSearch$ | async)) {
        <div class="mdsf-btn mdsf-hitarea d-none d-md-flex"
          (click)="openModal()"
          >
          <i class="fa fa-search" title="{{ 'open_modal' | translate }}"></i>
        </div>
      }
      @if ((navigationControlFacade.showClose$ | async)) {
        <div class="mdsf-btn mdsf-hitarea"
          (click)="localClose()"
          >
          <i class="fa fa-close"></i>
        </div>
      }
</div>
</ng-template>

<!-- Content -->
@if ({ showHome: (showHome$ | async), themeColor: (appSharedFacade.themeColor$ | async), currentSelectedNode: (nodeSharedFacade.currentSelectedNode$ | async), currentSelectedSettings: (nodeSharedFacade.currentSelectedSettings$ | async), currentUser: (appSharedFacade.currentUser$ | async)}; as data) {
  <nav class="msf-navbar"
    role="navigation"
    >
    @if (data.themeColor) {
      <div
      class="hline {{ data.themeColor }}Background"></div>
    }
    <div class="mdsf-container">
      @if (data.showHome) {
        <div class="left mdsf-btn d-none d-md-flex" [routerLink]="'/'">
          <a [routerLink]="'/'"><i class="fa fa-home-alt black"></i></a>
          <!--<i class="icon icon_arrow-left dark"></i>-->
        </div>
      }
    <ng-container *ngTemplateOutlet="dropdown_template;context:{
                  user: data.currentUser,
                  settings: data.currentSelectedSettings,
                  page: (appSharedFacade.page$(data.currentSelectedNode?.page) | async)}">
      </ng-container>
      @if ((navigationControlFacade.elearningUrl$ | async) === null && (appSharedFacade.metadata$ | async); as metadata) {
        <div class="mdsf-title truncate" (click)="localTitleClicked()">
          <!-- <span class="{{ data.themeColor }}">{{ (title$ | async) || (metadata$ | async)?.title }}</span> -->
          <span class="{{ data.themeColor }}">{{ metadata.title }}</span>
        </div>
      } @else {
        @if ((appSharedFacade.themeColor$ | async); as themeColor) {
          <div class="mdsf-title truncate">
            @if ((appSharedFacade.currentNodeBreadcrumbs$ | async); as breadcrumbs) {
              @for (breadcrumb of breadcrumbs; track trackByPageId(index, breadcrumb); let index = $index) {
        <ng-container *ngTemplateOutlet="breadcrumb_entry_template;context:{
          page: (appSharedFacade.page$(breadcrumb.pageId) | async),
          routerLink: breadcrumb.routerLink,
          themeColor: themeColor}">
                </ng-container>
                @if (index < breadcrumbs.length - 1) {
                  <ng-container [ngTemplateOutlet]="breadcrumb_separator_template" />
                }
              }
            }
          </div>
        }
      }
    <ng-container *ngTemplateOutlet="right_template;context:{
                  user: data.currentUser,
                  settings: data.currentSelectedSettings,
                  page: (appSharedFacade.page$(data.currentSelectedNode?.page) | async),
                  currentUrl: (navigationControlFacade.currentUrl$ | async)}">
      </ng-container>
    </div>
  </nav>
}
